import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { AddressSchedulerForm } from '../../../address-scheduler/AddressSchedulerFormPage/AddressSchedulerForm'
import { usePendingWorkflowStatus } from './usePendingWorkflowStatus'
import { StatusChip } from './StatusChip'
import { useLocation } from '../../../../api/apiQueries'
import { USAddressCountry } from '../../../../api/models'

export const AddressForm: FC = () => {
  const { sid: locationId } = useParams()
  const location = useLocation(locationId)
  const isPendingWorkflow = usePendingWorkflowStatus(locationId)
  return (
    locationId && (
      <AddressSchedulerForm
        title={'Edit Address'}
        instructions={'If you edit anything on this page you will need to validate the customer’s address.'}
        showAdditionalLocationFields={true}
        sid={locationId}
        statusChip={
          isPendingWorkflow ? (
            <StatusChip
              data-testid="address-info-workflow-status-chip"
              status="pending"
              tooltipPlacement="right"
              tooltipText="Updates typically take a few moments"
            />
          ) : null
        }
        country={location.data?.address?.country || USAddressCountry.US}
      />
    )
  )
}
